import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button from "@react/shared/ui/Button"

const Header = ({ count, onExport, onNewClick, onImportClick, templatesUrl }) => (
  <div className="flex items-start justify-between gap-6 mb-6">
    <div className="flex items-baseline gap-3">
      <h1 className="text-2xl font-semibold text-slate-900">
        {I18n.t("navigation.project_quotes")}
      </h1>
      <span className="text-sm text-slate-500">
        {I18n.t("quotes.project_index.count", { count: count ?? 0 })}
      </span>
    </div>

    <div className="flex items-center gap-2">
      <Button variant="secondary" data-toggle="modal" data-target="#filter-quotes">
        <FontAwesomeIcon icon="filter" className="text-slate-500" />
        {I18n.t("button.filter")}
      </Button>

      <Button variant="secondary" onClick={onExport}>
        <FontAwesomeIcon icon="file-export" className="text-slate-500" />
        {I18n.t("button.export")}
      </Button>

      <Button variant="secondary" onClick={onImportClick}>
        <FontAwesomeIcon icon="file-import" />
        DPGF
      </Button>

      {templatesUrl && (
        <Button variant="secondary" onClick={() => { window.location.href = templatesUrl }}>
          <FontAwesomeIcon icon="layer-group" className="text-slate-500" />
          {I18n.t("quotes.project_templates.menu")}
        </Button>
      )}

      <Button variant="primary" onClick={onNewClick}>
        <FontAwesomeIcon icon="plus" />
        {I18n.t("quotes.quote")}
      </Button>
    </div>
  </div>
)

export default Header
